import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { loadDOMComponent } from '../../../../../helpers';
import { AppContextProvider } from '../../../../../Services/AppContext';
import { store } from '../../../../../store/store';
import UserFamilyMemberCollapseMenu from './UserFamilyMemberCollapseMenu';

loadDOMComponent({
	selector: 'react-user-family-member-collapse-menu',
	// @ts-ignore
	callback: ({ container, context, props }) => {
		const familyMemberUserId = container.getAttribute('familyMemberUserId');
		const familyMemberId = parseInt(container.getAttribute('familyMemberId'));
		const userId = container.getAttribute('userId');
		const allowShareChildren = container.getAttribute('allowShareChildren');

		ReactDOM.render(
			<Provider store={store}>
				<AppContextProvider {...context}>
					<UserFamilyMemberCollapseMenu
						familyMemberUserId={familyMemberUserId}
						userId={userId}
						allowShareChildren={allowShareChildren}
						familyMemberId={familyMemberId}
					/>
				</AppContextProvider>
			</Provider>,
			container,
		);
	},
});
